import * as _ from 'lodash';

export const imageExtensions = ['png', 'jpg', 'jpeg', 'svg', 'eps', 'bmp', 'psd', 'gif', 'tiff', 'tif', 'ai'];
export const videoExtensions = ['wmv', 'mov', 'qt', 'avi', 'mpg', 'mpeg', 'mov', 'mp4'];
export const documentExtensions = ['docx', 'doc', 'odt', 'rtf', 'pdf', 'ai', 'csv', 'xls', 'xlsx'];
export const otherExtensions = ['zip'];

export function getFileType(extension: string): FileType {
    const loweredExtension = _.toLower(extension);

    if (_.includes(imageExtensions, loweredExtension)) {
        return FileType.Image;
    }

    if (_.includes(videoExtensions, loweredExtension)) {
        return FileType.Video;
    }

    if (_.includes(documentExtensions, loweredExtension)) {
        return FileType.Document;
    }

    return FileType.File;
}

export enum FileType {
    Image = 'image',
    Video = 'video',
    Document = 'document',
    File = 'file'
}

export enum ImageExtensions {
    Png = 'png',
    Jpg = 'jpg',
    Jpeg = 'jpeg',
    Svg = 'svg',
    Eps = 'eps',
    Bmp = 'bmp',
    Psd = 'psd',
    Gif = 'gif',
    Tiff = 'tiff',
    Tif = 'tif'
}

export enum FileExtensions {
    Docx = 'docx',
    Doc = 'doc',
    Odt = 'odt',
    Rtf = 'rtf',
    Pdf = 'pdf',
    Ai = 'ai'
}

export enum DocumentExtensions {
    Pdf = 'application/pdf',
    Csv = 'text/csv'
}
